// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const OrdersListClient = registerClientReference(
    function() { throw new Error("Attempted to call OrdersListClient() from the server but OrdersListClient is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/web/src/app/(seller)/seller/orders/orders-list-client.tsx <module evaluation>",
    "OrdersListClient",
);
